import React from "react";
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router-dom";
import ConsoleLogger from "../Utils/ConsoleLogger";
import Loading from 'react-loading-bar';
import 'react-loading-bar/dist/index.css';
import Footer from "./Footer";
import ContactForm from "./ContactForm";
import CustomMap from "./CustomMap";
import Food from "./HexaFood";

let config = require('../Config/appConfig.json');
let UR_GET_ROUTE_DETAILS = config.GET_ROUTE_DETAILS;
let URL_DECODE_POLYLINE = config.DECODE_POLYLINE_END_POINT;
let DOWNLOAD_LINK_ANDROID = config.DOWNLOAD_LINK_ANDROID;
let DOWNLOAD_LINK_IOS = config.DOWNLOAD_LINK_IOS;
const context = "Home.js";
var self = null;
@inject("appStore")
@observer
class Home extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            showProgress: false,
            items: [],
            routes: [],
            pathCoordinates: [],
            lat: 0.0000,
            lng: 0.0000,
            description: "",
            stops_array: []
        };
    }

    componentWillMount = () => {
        self = this;

        this.fetchRouteDetails();
    }

    fetchRouteDetails = () => {

        this.setState({
            showProgress: true
        })
        var route_list = [];
        fetch(UR_GET_ROUTE_DETAILS, {
            method: 'GET'
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (responseJson) {
                try {

                    var resJson = JSON.stringify(responseJson);

                    responseJson.data.forEach(element => {
                        route_list.push(element.name)
                    });
                    self.setState({
                        items: responseJson.data,
                        routes: route_list,
                        showProgress: false
                    })


                    console.log(responseJson)
                } catch (e) {

                }
            })
            .catch(function (error) {


            });
    }



    generateRouteDropDown = (route_josn_array) => {
        var routeListDropDown = null
        routeListDropDown = route_josn_array.map(function (content, i) {
            return (
                <option value={content.name} key={i}>{content.name}</option>
            )
        });

        return routeListDropDown;
    }

    generateStopsUi = (stops_array) => {
        var stopsUi = null;
        stopsUi = stops_array.map(function (element, i) {
            return (
                <div>
                    <a className="btn-get-the-app hover-box-effect" style={{ width: 325, margin: 3 }}>
                        <i className="fa fa-map-marker" ></i> <span style={{ marginLeft: 10, fontSize: 15 }}>{element}</span>
                    </a>
                    {/* <h5><i className="fa fa-map-marker"></i>
                        <span style={{ 'marginLeft': '10px', 'color': 'black', 'fontWeight': '1', marginBottom : 10 }}>
                            {element}</span>
                    </h5> */}
                </div>
            )
        });

        var ui = (<div className="form-group scrollbar" style={{ marginTop: 70, 'overflowY': 'scroll', maxHeight: 400 }} id="style-3">
            {stopsUi}
        </div>)
        return ui;
    }
    decodePolyLine = (event) => {
        var route_name = event.target.value;
        var polyline = null;
        this.state.items.map(function (content, i) {
            if (content.name === route_name) {
                polyline = content.polyline,
                    self.setState({
                        description: content.description,
                        stops_array: content.stop_names
                    })
            }
        });

        console.log(polyline);
        var bodyData = {
            'polyline': polyline
        };

        this.setState({
            showProgress: true
        })
        fetch(URL_DECODE_POLYLINE, {
            method: 'POST',
            body: JSON.stringify(bodyData)
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (responseJson) {
                try {

                    var resJson = JSON.stringify(responseJson);

                    self.setState({
                        pathCoordinates: responseJson.points,
                        lat: responseJson.points[0]['lat'],
                        lng: responseJson.points[0]['lng'],
                        showProgress: false
                    });

                    console.log(responseJson)
                } catch (e) {

                }
            })
            .catch(function (error) {


            });

    }


    componentDidMount = () => {
        //console.log("PROPS", this.props);
    }

    openDownloadLink = (where_to) => {
        var link_to_open = null;
        if (where_to === "android") {
            link_to_open = DOWNLOAD_LINK_ANDROID;
        } else if (where_to === "iOS") {
            link_to_open = DOWNLOAD_LINK_IOS;
        }

        if (link_to_open === null) {

        } else {
            var win = window.open(link_to_open, '_blank');
            win.focus();
        }
    }
    render() {
        var routeDropDownUi = null;
        var stopsUi = null;
        if (this.state.routes.length > 0 && routeDropDownUi == null) {
            routeDropDownUi = this.generateRouteDropDown(this.state.items)
        }
        if (this.state.stops_array.length > 0) {
            stopsUi = this.generateStopsUi(this.state.stops_array)
        }
        return (
            <div>


              
<Food/>
             
            </div>
        );
    }
}

export default withRouter(Home);


// WEBPACK FOOTER //
// ./src/Pages/Home.js